import { CREATE_EVENT, DELETE_EVENT, FETCH_EVENTS, NO_EVENTS } from '../../_actions/types';

const defaultState = {
  newEvent: '',
  allEvents: {}
}

export default function(state=defaultState, action) {
  switch (action.type){
    case CREATE_EVENT:
      return { ...state }
    case DELETE_EVENT:
      return { ...state }
    case FETCH_EVENTS:
      return{ ...state, allEvents: action.payload }
    case NO_EVENTS:
      return{ ...state, allEvents: {} }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/components/schedule/schedule_reducer.js